import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import CompanyAvatar from '../../../components/CompanyAvatar';
// config
import { NAVBAR } from '../../../config';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { user } = useAuth();

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <Link underline="none" color="inherit" component={RouterLink} to={'/'}>
        <CompanyAvatar />
      </Link>

      <Box
        sx={{
          ml: 2,
          transition: (theme) =>
            theme.transitions.create('width', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapse && {
            ml: 0,
            width: 0,
          }),
        }}
      >
        <Link underline="none" color="inherit" component={RouterLink} to={`${PATH_DASHBOARD.user.account}?tab=company`}>
          {/* <Tooltip title={user?.company?.name}> */}
          <Typography
            variant="subtitle2"
            sx={{
              color: (theme) => theme.palette.common.white,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: NAVBAR.DASHBOARD_WIDTH - 133,
            }}
          >
            {user?.company?.name}
          </Typography>
          {/* </Tooltip> */}
        </Link>

        <Link underline="none" color="inherit" component={RouterLink} to={`${PATH_DASHBOARD.user.account}?tab=general`}>
          {/* <Tooltip title={user?.name}> */}
          <Typography
            variant="body2"
            line={1}
            sx={{
              color: 'text.secondary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: NAVBAR.DASHBOARD_WIDTH - 133,
            }}
          >
            {user?.name}
          </Typography>
          {/* </Tooltip> */}
        </Link>
      </Box>
    </RootStyle>
  );
}
